export default {
    title: 'Star Gacha',
    labels: {
        inventory: 'My Avatars',
        machine: 'Star Gacha Machine',
    },
    messages: {
        insufficientStars: 'Not enough stars. 😢',
        ctaText: 'Tap me to put it in your collection!',
    },
};
